import { consoleLogger } from '../logging/consoleLogger';
import { ConnectionEligibilityDataEntryName } from '../constants/utiq';

export const handleConnectionEligibilityData = ({
  connectionEligibilityData,
  onEligibilityCheckedCallback,
}) => {
  if (
    typeof connectionEligibilityData === 'object' &&
    Object.keys(connectionEligibilityData).length !== 0 &&
    typeof connectionEligibilityData.isEligible === 'boolean'
  ) {
    localStorage.setItem(
      ConnectionEligibilityDataEntryName,
      JSON.stringify(connectionEligibilityData),
    );
    consoleLogger.logInfo(
      `Written new ${ConnectionEligibilityDataEntryName} local storage entry: ${JSON.stringify(
        connectionEligibilityData,
      )}`,
    );
    if (typeof onEligibilityCheckedCallback === 'function') {
      onEligibilityCheckedCallback(connectionEligibilityData.isEligible);
    }
  }
};
